import { defineStore } from 'pinia'
import { ref } from 'vue'
import { orderApi } from '@/services/api'

export const useOrderStore = defineStore('order', () => {
  // 状态
  const orderData = ref<any>(null)
  
  // actions
  const setOrderData = (data: any) => {
    orderData.value = data
  }

  const fetchOrderData = async (contractId: number) => {
    try {
      const response = await orderApi.getDetail(contractId, 0)
      if (response.code === 0 && response.data) { 
        //response.data.attrs = response.data.attrs ? JSON.parse(response.data.attrs) : null
        orderData.value = response.data 
      }
    } catch (error) {
      console.error('获取订单数据失败:', error)
      return null
    }
  }

  const clearOrderData = () => {
    orderData.value = null
  }

  return {
    orderData,
    setOrderData,
    fetchOrderData,
    clearOrderData
  }
}) 